import React from "react";
import { MenuItem, TextField } from "@mui/material";
import { CANADIAN_PROVINCES } from "../constants/RegionalLocationList";

const BillingProvinceSelect = ({ value, onChange }) => (
  <TextField
    fullWidth
    required
    select
    label="Province/Territory"
    value={value}
    onChange={onChange}
  >
    {CANADIAN_PROVINCES.map(({ code, name }) => (
      <MenuItem key={code} value={code}>
        {name} ({code})
      </MenuItem>
    ))}
  </TextField>
);

export default BillingProvinceSelect;
